/*
 * @Author: liyu
 * @Date: 2022-04-18 16:37:17
 * @LastEditTime: 2022-05-10 19:31:34
 * @Description: file content
 * @FilePath: /sensors-www/src/components/ArticleFooter/index.tsx
 */
import React from 'react'
import ScanCodeConsultButton from 'components/ScanCodeConsultButton'
import * as styles from './index.module.less'
import EntertainmentButton from 'components/Entertainment/EntertainmentButton'
import classNames from 'classnames'

interface ArticleFooterProps {
  title?: string
  gameDsc?: string
  btnText?: string
  flag?: boolean
  orderText?: string
  orderHref?: string
  btnHref?: string
  className?: string
}
const renderBtn = (btnText, btnHref) => {
  return (
    <EntertainmentButton btnType="primary" href={btnHref} target="_blank">
      {btnText}
    </EntertainmentButton>
  )
}
const renderCodeBtn = (btnText) => {
  return (
    <ScanCodeConsultButton
      buttonText={btnText}
      qrcode={require(`assets/images/solution/game/mini-program-code.png`).default}
      alt={btnText}
      imgBottomText="微信扫码&nbsp;免费获取"
    />
  )
}
const ArticleFooter: React.FC<ArticleFooterProps> = ({
  title,
  gameDsc,
  btnText,
  btnHref,
  flag,
  orderText,
  orderHref,
  className,
}) => {
  return (
    <div className={classNames(styles.immediateAppointment, className)}>
      <div className="appointment-title">{title}</div>
      <div className="appointment-dsc">{gameDsc}</div>
      <div className="appointment-btn">
        {flag ? renderCodeBtn(btnText) : renderBtn(btnText, btnHref)}
        <EntertainmentButton href={orderHref} target="_blank">
          {orderText}
        </EntertainmentButton>
      </div>
    </div>
  )
}

export default ArticleFooter
